/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSubscriptionPayments } from 'app/entities/subscription-payment/subscription-payment.reducer';
import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { createEntity, getEntity, reset, updateEntity } from './subscription-billing.reducer';

export const SubscriptionBillingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const subscriptionPayments = useAppSelector(state => state.subscriptionPayment.entities);
  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const subscriptionBillingEntity = useAppSelector(state => state.subscriptionBilling.entity);
  const loading = useAppSelector(state => state.subscriptionBilling.loading);
  const updating = useAppSelector(state => state.subscriptionBilling.updating);
  const updateSuccess = useAppSelector(state => state.subscriptionBilling.updateSuccess);

  const handleClose = () => {
    navigate(`/subscription-billing${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSubscriptionPayments({}));
    dispatch(getContactDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.validTill !== undefined && typeof values.validTill !== 'number') {
      values.validTill = Number(values.validTill);
    }
    if (values.remindFrom !== undefined && typeof values.remindFrom !== 'number') {
      values.remindFrom = Number(values.remindFrom);
    }
    if (values.lockOutOn !== undefined && typeof values.lockOutOn !== 'number') {
      values.lockOutOn = Number(values.lockOutOn);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...subscriptionBillingEntity,
      ...values,
      payment: subscriptionPayments.find(it => it.id.toString() === values.payment?.toString()),
      contactDetails: contactDetails.find(it => it.id.toString() === values.contactDetails?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...subscriptionBillingEntity,
          payment: subscriptionBillingEntity?.payment?.id,
          contactDetails: subscriptionBillingEntity?.contactDetails?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.subscriptionBilling.home.createOrEditLabel" data-cy="SubscriptionBillingCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.subscriptionBilling.home.createOrEditLabel">
              Create or edit a SubscriptionBilling
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="subscription-billing-id"
                  label={translate('tinyMedicRestApp.subscriptionBilling.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.firstName')}
                id="subscription-billing-firstName"
                name="firstName"
                data-cy="firstName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.lastName')}
                id="subscription-billing-lastName"
                name="lastName"
                data-cy="lastName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.customerId')}
                id="subscription-billing-customerId"
                name="customerId"
                data-cy="customerId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.validTill')}
                id="subscription-billing-validTill"
                name="validTill"
                data-cy="validTill"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.remindFrom')}
                id="subscription-billing-remindFrom"
                name="remindFrom"
                data-cy="remindFrom"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.lockOutOn')}
                id="subscription-billing-lockOutOn"
                name="lockOutOn"
                data-cy="lockOutOn"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.active')}
                id="subscription-billing-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.lastupdated')}
                id="subscription-billing-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.microSec')}
                id="subscription-billing-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.timestampentry')}
                id="subscription-billing-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionBilling.cursor')}
                id="subscription-billing-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="subscription-billing-payment"
                name="payment"
                data-cy="payment"
                label={translate('tinyMedicRestApp.subscriptionBilling.payment')}
                type="select"
                required
              >
                <option value="" key="0" />
                {subscriptionPayments
                  ? subscriptionPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="subscription-billing-contactDetails"
                name="contactDetails"
                data-cy="contactDetails"
                label={translate('tinyMedicRestApp.subscriptionBilling.contactDetails')}
                type="select"
                required
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/subscription-billing" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SubscriptionBillingUpdate;
